const DestinationTypes = {
  provider: 'provider',
  customDestination: 'destination',
  network: 'network',
  pollDestination: 'poll_destination'
};

export default DestinationTypes;
